import { cx } from '../cx';

/**
 * Indeterminate progress. A rotating hairline arc - no pulsing dots, no bounce.
 * Standing alone it takes a `label` and announces itself; inside a Button it is
 * decoration, because the button already carries `aria-busy`.
 */
export interface SpinnerProps {
  readonly size?: string | undefined;
  readonly className?: string | undefined;
  readonly label?: string | undefined;
}

export function Spinner({ size = '1em', className, label }: SpinnerProps) {
  const arc = (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      className={cx('animate-spin motion-reduce:animate-none', className)}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" opacity="0.25" />
      <path d="M21 12a9 9 0 0 0-9-9" />
    </svg>
  );

  // The announcement lives on a wrapper rather than the graphic: an <svg> with
  // both a role and aria-hidden is a contradiction assistive tech resolves
  // inconsistently.
  return label === undefined ? (
    arc
  ) : (
    <span role="status" aria-label={label} className="inline-flex">
      {arc}
    </span>
  );
}
